import React from "react";

const Timeless = props => (
  <svg viewBox="0 0 26 13" fill="none" {...props}>
    <path
      d="M19.563.25C16.358.25 14.015 3.492 13 5.21 11.945 3.493 9.602.25 6.398.25 3.118.25.5 3.063.5 6.5c0 3.477 2.617 6.25 5.898 6.25 3.204 0 5.547-3.203 6.602-4.922 1.016 1.719 3.36 4.922 6.563 4.922 3.28 0 5.937-2.773 5.937-6.25 0-3.438-2.656-6.25-5.938-6.25zM6.398 11.5c-2.578 0-4.648-2.227-4.648-5 0-2.734 2.07-5 4.648-5 3.047 0 5.313 3.945 5.899 5-.586 1.094-2.852 5-5.899 5zm13.165 0c-3.047 0-5.313-3.906-5.899-5 .586-1.055 2.852-5 5.899-5 2.578 0 4.687 2.266 4.687 5 0 2.773-2.11 5-4.688 5z"
      fill="currentColor"
      fillOpacity={0.3}
    />
  </svg>
);

export default Timeless;
